<template>

<form
  id="statusForm"
  class="mx-auto col-sm-8"
  @submit.prevent
>
  <div class="form-group" :class="{ 'has-error': errors.has('name') }">
    <label for="name">{{ $t('name') }}</label>
    <input
      type="text"
      id="name"
      name="name"
      class="form-control"
      :placeholder="$t('type_name')"
      v-model="status.name"
      v-validate="'required'"
      @input="status.name = status.name.toUpperCase()"
    >

    <small v-show="errors.has('name')" class="form-text text-muted">
      {{ errors.first('name') }}
    </small>
  </div>

  <div class="form-group">
    <label for="location">{{ $t('location') }}</label>
    <Combobox
      multiple
      :disabled="!status.name"
      class="bg-white"
      name='location'
      label="location"
      :hasErrors="errors.has('location')"
      :placeholder="$t('select_a_item')"
      :options="allLocations"
      :initial-value="status.locations"
      v-model="status.locations"
      v-validate="'required'"
    />

    <small v-show="errors.has('location')" class="form-text">
      {{ errors.first('location') }}
    </small>
  </div>

  <div class="row">
    <div class="form-group col-6">
      <div class="switch">
        <label for="complementary_field">{{ $t('complementary_field') }}</label>
        <div class="onoffswitch2">
          <input
            type="checkbox"
            class="onoffswitch2-checkbox"
            id="complementary_field"
            v-model="status.complementaryField">
          <label class="onoffswitch2-label" for="complementary_field">
              <span class="onoffswitch2-inner"></span>
              <span class="onoffswitch2-switch"></span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-4 col-sm-offset-2">
      <LoaderButton
        @click="onClick"
      >
        {{ $t('save') }}
      </LoaderButton>
    </div>
  </div>
</form>

</template>

<script>
import { mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import Combobox from '@/components/shared/ComboBox'
import allLocations from '@/config/locations'

export default {
  name: 'StatusForm',
  components: {
    LoaderButton,
    Combobox
  },

  data() {
    return {
      allLocations
    }
  },

  props: {
    status: {
      type: Object,
      default: () => ({
        id: undefined,
        name: '',
        locations: [],
        complementaryField: false
      })
    }
  },

  methods: {
    ...mapActions('status', [
      'create',
      'edit',
      'cleanState'
    ]),

    async onClick (evtClick, doneFn) {
      const isValid = await this.$validator.validateAll()

      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))

        return this.$store.dispatch('notify/error', err)
      }

      const onlyLocationsName = this.status.locations.map(item => (
        typeof item === 'object'
          ? item.location
          : item
      ))

      const data = { ...this.status, locations: onlyLocationsName }

      const result = this.status.id
        ? await this.edit({ id: this.status.id, data })
        : await this.create(data)

      if (result) {
        this.$router.push({ name: 'liststatus' })
      }
    }
  },

  destroyed () {
    this.cleanState()
  }
}
</script>
